<template>
  <div class="not-eligibl">
    <div class="title">您无法参与信用购领豪礼活动。</div>
    <div class="wrapper">
      <div class="tit">
        成为内蒙古移动黑卡plus会员
        <br />尽享会员十大权益
      </div>
      <div class="goods-show">
        <img :key="index" :src="goods" alt v-for="(goods, index) in goodsList" />
      </div>
      <div class="footer">
        <div class="join-right-now">
          <button @click="$router.push({name: 'home'})">立即加入</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {
      goodsList: [
        require('../../assets/img/hornor-buy/goods-1.png'),
        require('../../assets/img/hornor-buy/goods-2.png'),
        require('../../assets/img/hornor-buy/goods-3.png'),
        require('../../assets/img/hornor-buy/goods-4.png')
      ]
    }
  }
}
</script>

<style lang="less" scoped>
.not-eligibl {
  width: 100%;
  min-height: 13.34rem;
  background: url("../../assets/img/hornor-buy/faild.png") center no-repeat #fff;
  background-size: 7.5rem 13.34rem;
  .title {
    padding: 2.5rem 0 0.76rem;
    font-size: 0.3rem;
    text-align: center;
    color: #ff5753;
  }
  .wrapper {
    .tit {
      font-size: 0.36rem;
      color: #4c4c4c;
      font-weight: bold;
      text-align: center;
    }
    .goods-show {
      padding: 0 1.2rem;
      .flex-between;
      flex-wrap: wrap;
      img {
        margin-top: 0.3rem;
        width: 2.3rem;
        height: 2.3rem;
        object-fit: contain;
        box-shadow: 4.769px 7.632px 40px 0px rgba(255, 89, 85, 0.28);
      }
    }
  }
  .footer {
    left: 0;
    right: 0;
    position: absolute;
    top: 10.4rem;
  }
  .join-right-now {
    width: 4.84rem;
    height: 1.14rem;
    margin: 0 auto 0.5rem;
    button {
      width: 100%;
      height: 100%;
      border-radius: 0.6rem;
      color: #fff;
      background-image: linear-gradient(
        180deg,
        #ffa99b 0%,
        #ff7462 54%,
        #ff4a37 100%
      );
      box-shadow: 0 2px 13px 0 rgba(255, 149, 149, 0.66);
      font-size: @fz28;
      font-weight: 660;
    }
  }
}
</style>
